Node.bind = function (deviceTypes, node, mesh) {
    Utils.inheritMethods(node, new Node());

    node.bind(deviceTypes, mesh);

    return node;
}

/**
 *
 */
function Node() {
    /**
     *
     */
    Node.prototype.bind = function (deviceTypes, mesh) {
        this.class = "Node";
        this.__mesh = mesh;

        for (var n in this.devices) {
            Device.bind(deviceTypes, this, this.devices[n]);
        }

        if (!this.groups) {
            this.groups = [];
        }

        for (var n in this.groups) {
            Group.bind(this, this.groups[n]);
        }
    };

    /**
     *
     */
    Node.prototype.getDevice = function (id) {
        for (var n in this.devices) {
            if (this.devices[n].id === id) {
                return this.devices[n];
            }
        }

        throw "Cannot find Device [" + id + "].";
    };

    /**
     *
     */
    Node.prototype.getElement = function (id) {
        if (id.indexOf(".") < 0) {
            return this.getDevice(id);
        }

        var ids = id.split(".");
        var device = this.getDevice(ids[0]);

        for (var n in device.actors) {
            if (device.actors[n].id === ids[1]) {
                return device.actors[n];
            }
        }

        for (var n in device.sensors) {
            if (device.sensors[n].id === ids[1]) {
                return device.sensors[n];
            }
        }

        throw "Cannot find Element [" + id + "].";
    };

    /**
     *
     */
    Node.prototype.getGroup = function (id) {
        for (var n in this.groups) {
            if (this.groups[n].id === id) {
                return this.groups[n];
            }
        }

        throw "Cannot find Group [" + id + "].";
    };

    /**
     *
     */
    Node.prototype.replaceGroup = function (group) {
        for (var n in this.groups) {
            if (this.groups[n].id === group.id) {
                this.groups[n] = group;

                return;
            }
        }

        throw "Cannot find Group [" + group.id + "].";
    };

    /**
     *
     */
    Node.prototype.getEventProcessor = function (id) {
        for (var n in this.eventProcessors) {
            if (this.eventProcessors[n].id === id) {
                return this.eventProcessors[n];
            }
        }

        throw "Cannot find Event Processor [" + id + "].";
    };

    /**
     *
     */
    Node.prototype.getAllServices = function (id) {
        var services = [];

        for (var n in this.services) {
            services.push({
                type: "nodeService",
                label: this.services[n].label,
                service: this.services[n].id
            });
        }

        for (var n in this.devices) {
            for (var m in this.devices[n].__type.services) {
                services.push({
                    type: "deviceService",
                    label: this.devices[n].label + "." + this.devices[n].__type.services[m].label,
                    device: this.devices[n].id,
                    service: this.devices[n].__type.services[m].id
                });
            }

            for (var m in this.devices[n].actors) {
                for (var l in this.devices[n].actors[m].__type.services) {
                    services.push({
                        type: "actorService",
                        label: this.devices[n].label + "." + this.devices[n].actors[m].label + "." + this.devices[n].actors[m].__type.services[l].label,
                        device: this.devices[n].id,
                        actor: this.devices[n].actors[m].id,
                        service: this.devices[n].actors[m].__type.services[l].id
                    });
                }
            }
        }

        return services;
    };

    /**
     *
     */
    Node.prototype.getService = function (id) {
        for (var n in this.services) {
            if (this.services[n].id === id) {
                return this.services[n];
            }
        }

        throw "Cannot find Service [" + id + "].";
    };

    /**
     *
     */
    Node.prototype.getAllActors = function (id) {
        var actors = [];

        for (var n in this.devices) {
            for (var m in this.devices[n].actors) {
                actors.push(this.devices[n].actors[m]);
            }
        }

        return actors;
    };

    /**
     *
     */
    Node.prototype.getActor = function (fullId) {
        var ids = fullId.split(".");
        var actors = [];

        for (var n in this.devices) {
            if (this.devices[n].id === ids[0]) {
                for (var m in this.devices[n].actors) {
                    if (this.devices[n].actors[m].id === ids[1]) {
                        return this.devices[n].actors[m];
                    }
                }
            }
        }

        throw "Cannot find Actor [" + fulld + "].";
    };

    /**
     *
     */
    Node.prototype.getAllGroups = function () {
        var groups = [];

        for (var n in this.groups) {
            groups.push.apply(groups, this.groups[n].getAllGroups());
            groups.push(this.groups[n]);
        }

        return groups;
    };

    /**
     *
     */
    Node.prototype.getJob = function (id) {
        for (var n in this.jobs) {
            if (this.jobs[n].id === id) {
                return this.jobs[n];
            }
        }

        throw "Cannot find Job [" + id + "].";
    };

    /**
     *
     */
    Node.prototype.getContextObject = function (label) {
        for (var n in this.services) {
            if (this.services[n].label.toLowerCase() === label.toLowerCase()) {

                // TODO Trick, we do not have a Service class

                this.services[n].class = "Service";

                return this.services[n];
            }
        }

        for (var n in this.devices) {
            if (this.devices[n].label.toLowerCase() === label.toLowerCase()) {
                return this.devices[n];
            }
        }

        for (var n in this.groups) {
            if (this.groups[n].label.toLowerCase() === label.toLowerCase()) {
                console.log("Test [" + this.groups[n].label.toLowerCase() + "] against [" + label.toLowerCase() + "]");
                return this.groups[n];
            }
        }

        return null;
    };

    /**
     *
     */
    Node.prototype.isSimulated = function () {
        return this.simulated;
    };
}
